// extracted by mini-css-extract-plugin
module.exports = {"root":"Top_root__15S1D","header":"Top_header__1Q9ZT","headerText":"Top_headerText__3LvN7","headerTextLink":"Top_headerTextLink__3_kcB","result":"Top_result__3RMNF"};